module.exports = __webpack_public_path__ + "img/i-5.8b298852.svg";